import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';


function MaintenanceChip() {

    const { t } = useTranslation();

    return (
        <Chip
            icon={<ManageAccountsOutlinedIcon />}
            label={t('chip.maintenance')}
            variant="filled"
            color="error"
            size="medium"
            sx={{ width: '100%' }}
        />
    );
};

export default MaintenanceChip;